import client from '../httpClient';

const claimPostApi = (params) => {
  return client.post('/claims', params, { isShowLoading: true });
};

export default claimPostApi;
